import type { EditGraph } from "../contracts/edit-graph.js";
import { validateEditGraph } from "../validation/validate.js";

/** Deterministic JSON serialization for challenge links and adapter handoff. */
export function serializeEditGraph(graph: EditGraph): string {
  return JSON.stringify(graph);
}

/**
 * Parse + validate EditGraph JSON.
 * Invokes explicit v1 → v2 migration inside validateEditGraph.
 */
export function deserializeEditGraph(json: string): EditGraph {
  const parsed: unknown = JSON.parse(json);
  return validateEditGraph(parsed);
}

export function serializeSourcePackJson(pack: unknown): string {
  return JSON.stringify(pack);
}

export function roundTripJson<T>(value: T): T {
  return JSON.parse(JSON.stringify(value)) as T;
}
